import { I18n } from '@ngx-translate/i18n-polyfill';
import { Injectable } from '@angular/core';
import { fabric } from 'fabric_gesture';
import { Segment, ClosestSegment, Point, iPoint, iPolygon } from '../model/geometry';
import { PolygonStore } from '../model/polygon-store';
import 'parse';
const parse: typeof Parse = require('parse');
import { TchekOldService } from './tchek-old.service';
import { SearchTagCheckbox } from '../model/search';
import * as cloneDeep from 'lodash/cloneDeep';
import { ToastService } from './toast.service';
import { Subject } from 'rxjs';
import { Damage } from '../model/damage.model';
import { relativeTimeRounding } from 'moment';
import { Configuration } from 'jasmine-spec-reporter/built/configuration';
import { environment } from '../../environments/environment';
import { TchekImage } from '../model/image';
import { iaTag } from '../model/iaTag.model';
import { ImageClassification } from '../model/imageClassification.model';

// Extending fabric Point class to make a new one with uid attribute
fabric.iPoint = iPoint;

// Extending fabric Polygon class to make a new one with uid attribute
fabric.iPolygon = iPolygon;

@Injectable()
export class AnnotationService {
  // Distance threshold (in canvas pixels) below which clicks are considered on polygons edges
  public static _edgeDistanceThreshold = 5;

  _damageTypesOptions = [] // liste des pieces de voiture
  _damageDefaultTypes = [] // liste les damages par default 
  _damageAtributes = {} // liste les attributs par default 
  _partAtributes = {} // liste les attributs par default 
  _damageTypes = [] // ['Bosse', 'Rayure', 'Frottement', 'Enfoncement', 'Impureté', 'Phare cassé'] etc...;
  _partTypes = [] // ['Porte', 'Capot'] etc...;
  _imageClassification: iaTag[]
  selectAnnotation;
  private polygons: PolygonStore;
  private listPolygons = [];
  private drawingMode: boolean;
  public canvasRef: fabric.Canvas;
  private sequence: Number = 0;
  private cameraNumber = '0';
  private tchekId: string;
  fimage: fabric.Image;
  timer: any;
  typeDamage = '';
  type = 0;
  createNewAnnotation: boolean = false;
  allowPolygonSelection = false;
  private precisionModeEnabled = false;
  activeAnnotationType: SearchTagCheckbox[] = [];
  newAnnotation = new Subject<any>();

  private image: TchekImage
  private currentMode: string;

  hideList: SearchTagCheckbox[] = [
    {
      display: this.i18n({
        id: 'damage',
        value: 'Dommages',
        description: 'Dommages',
        meaning: "annotation"
      }), value: 'damage', checked: false
    },

    {
      display: this.i18n({
        id: 'annotation',
        value: 'Annotations',
        description: 'Annotations',
        meaning: "annotation"
      }), value: 'annotation', checked: false
    },

    {
      display: this.i18n({
        id: 'pieces',
        value: 'Pièces',
        description: 'Pièces',
        meaning: "annotation"
      }), value: 'piece', checked: false
    }];


  private activeImage = new Subject<any>();
  activeImageObs = this.activeImage.asObservable();
  getImageActive() {
    let tchekPtr = {
      __type: 'Pointer',
      className: 'Tchek',
      objectId: this.tchekId
    }
    const ImageActiveQ = parse.Object.extend("ImageActive");
    let query = new parse.Query(ImageActiveQ);
    if (this.image) {
      query.equalTo("imagePtr", this.image.getParseInstance());
    } else {
      query.equalTo("folder", this.cameraNumber);
      query.equalTo("sequence", this.sequence);
    }
    query.equalTo("tchekPtr", tchekPtr);
    query.first().then(
      data => {
        // console.log("dove active data", data);
        if (!data)
          this.activeImage.next([]);
        else
          this.activeImage.next(data.get('active') || []);
      },
      error => {
        console.log(error);
      }
    )
  }

  private annotationHide = new Subject<any>();
  annotationHideObs = this.annotationHide.asObservable();
  hideAnnotation(hide: boolean) {
    this.annotationHide.next(hide)
  }

  setHideList(list) {
    this.hideList = list;
    this.refreshAnnotation();
  }

  getHideList() {
    return this.hideList;
  }

  constructor(private _tchekService: TchekOldService,
    private readonly i18n: I18n,
    private readonly _toastService: ToastService) {
    this.polygons = new PolygonStore();
    this.drawingMode = false;
    if (parse.User.current().get("isSuperAdmin")) {
      //get Tags for IA
      const IATags = parse.Object.extend('IATags');
      const query = new parse.Query(IATags);
      query.find().then(
        tags => {
          tags.forEach(tag => {
            if (tag.get("type") == "part") {
              this._partTypes.push(tag.get("label"))
              this._partAtributes[tag.get("label")] = tag.get("attributes");
            } else if (tag.get("type") == "damage") {
              this._damageTypes.push(tag.get("label"));
              this._damageAtributes[tag.get("label")] = tag.get("attributes");

              if (tag.get("default")) {
                this._damageDefaultTypes.push(tag.get("label"))
              }
            }
          });
          this._partTypes.forEach(element => {
            if (element != "")
              this._damageTypesOptions.push({ key: element, value: element })
          });
          this._partTypes.sort()
          this._damageTypes.sort()
        },
        error => {
          console.error(error);
        }
      );
    }
  }

  getAllImageClassification(): Promise<ImageClassification[]> {
    return new Promise((resolve, reject) => {
      const ImageActiveQ = parse.Object.extend("ImageClassification");
      let query = new parse.Query(ImageActiveQ);
      query.limit(10000000000)
      query.find().then(
        data => {
          resolve(data.map<ImageClassification>(o => new ImageClassification(o)))
        },
        error => {
          resolve([])
          console.log(error);
        }
      )
    })
  }


  getImageClassification(tchekId: string): Promise<ImageClassification[]> {
    return new Promise((resolve, reject) => {
      let tchekPtr = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchekId
      }
      const ImageActiveQ = parse.Object.extend("ImageClassification");
      let query = new parse.Query(ImageActiveQ);
      query.equalTo("tchekPtr", tchekPtr);
      query.find().then(
        data => {
          resolve(data.map<ImageClassification>(o => new ImageClassification(o)))
        },
        error => {
          resolve([])
          console.log(error);
        }
      )
    })
  }

  getImageClassificationList(): Promise<iaTag[]> {
    return new Promise((resolve, reject) => {
      if (this._imageClassification)
        resolve(this._imageClassification)
      else {
        const IATags = parse.Object.extend('IATags');
        const query = new parse.Query(IATags);
        query.find().then(
          tags => {
            this._imageClassification = []
            tags.forEach(tag => {
              if (tag.get("type") === 'imageClassification') {
                this._imageClassification.push(new iaTag(tag))
              }
            })
            resolve(this._imageClassification)
          });
      }
    })
  }

  getDamageAttributes() {
    return new Promise((resolve, reject) => {
      if (parse.User.current().get("isSuperAdmin")) {
        const IATags = parse.Object.extend('IATags');
        const query = new parse.Query(IATags);
        let attribute = {};
        query.find().then(
          tags => {
            tags.forEach(tag => {
              if (tag.get("type") == "damage") {
                attribute[tag.get("label")] = tag.get("attributes");
              }
            });
            resolve(attribute)
          },
          error => {
            reject('error')
          }
        );
      }
    })
  }

  setDamageForAnnotation(damage: string, type: number) {
    this.typeDamage = damage;
    this.type = type;
    // console.log('setDamageForAnnotation ', damage)
  }
  theTimer;

  refreshAnnotation() {
    // console.log('refresh annotation');
    this.hideList.forEach(hide => {
      if (hide.value === 'damage')
        this.hideAnnotation(hide.checked)
    });

    let listPolyNew = [];
    if (this.currentMode === 'video') {
      //   console.log('annotaitons refreshAnnotation : ', this.cameraNumber, this.sequence);
      listPolyNew = this.listPolygons.filter(a => (a.camera === this.cameraNumber));
      listPolyNew = listPolyNew.filter(a => (a.sequence === this.sequence));
    } else {
      listPolyNew = this.listPolygons.filter(a => {
        if (a.image && this.image && a.image.id === this.image.id)
          return true
        else
          return false
      });
    }

    let listPolyNewTMP = [];
    listPolyNew.forEach(poly => {
      this.hideList.forEach(hide => {
        if (hide.value === 'annotation' && hide.checked === false && poly.type === 0)
          listPolyNewTMP.push(poly);
        if (hide.value === 'piece' && hide.checked === false && poly.type === 1)
          listPolyNewTMP.push(poly);
      });
    })

    listPolyNew = listPolyNewTMP;

    this.polygons = new PolygonStore();
    listPolyNew.forEach(polygon => {
      this.polygons.add(polygon.poly, false, polygon.label, polygon.id);
    });
    //  this.drawPolygons();
    clearTimeout(this.theTimer);
    this.theTimer = setTimeout(() => {
      this.drawPolygons();
    }, 200);
  }

  retrievedRois
  setCanvasRef(canvasRef: fabric.Canvas, relativePictureNumber, cameraNumber, tchekId, mode, image: TchekImage) {
    console.log('annotation setCanvasRef, :', relativePictureNumber, cameraNumber, tchekId, mode, image);
    if (this.fimage === undefined) return
    console.log('aaaaa test', mode);
    // this.currentMode = mode;
    this.image = image
    this.polygons = new PolygonStore();
    this.tchekId = tchekId;
    this.sequence = parseInt(relativePictureNumber, 10);
    this.cameraNumber = cameraNumber;
    this.canvasRef = canvasRef;
    this.listPolygons = [];
    this.getAnnotation(tchekId).then((retrievedRois2) => {
      let retrievedRois = cloneDeep(retrievedRois2)
      this.retrievedRois = retrievedRois
      retrievedRois.forEach(annotation => {
        const points = cloneDeep(annotation.get('polygons'));
        const uid = annotation.get('uid');
        let first = true;

        //console.log('points :', this.fimage.width, this.fimage.height)
        points.forEach(point => {
          point.x = point.x * this.fimage.getScaledWidth() / this.fimage.width + this.fimage.left;
          point.y = point.y * this.fimage.getScaledHeight() / this.fimage.height + this.fimage.top;
          if (first) {
            this.polygons.add(new fabric.iPolygon([new fabric.iPoint(point.x, point.y)]), false, annotation.get('label'), annotation.id);
            first = false;
          } else {
            this.polygons.continue(new fabric.iPoint(point.x, point.y), annotation.get('label'), annotation.id);
          }
        });
        // console.log('init poly', annotation.get('label'), annotation.id);
        this.polygons.last().strokeDashArray = undefined;
        this.polygons.all().forEach(poly => {
          if (poly.points.length > 0) {
            const index = this.listPolygons.findIndex(a => (a.uid === poly.uid));
            if (index === -1) {
              const newPoly = {
                camera: annotation.get('folder'), sequence: annotation.get('sequence'),
                poly: poly, image: annotation.get('imagePtr') ? new TchekImage(annotation.get('imagePtr')) : undefined,
                uid: poly.uid, annotation: annotation, label: annotation.get('label'), id: annotation.id, type: annotation.get('type')
              };
              this.listPolygons.push(newPoly);
            }
          }
        });
      });
      this.refreshAnnotation();
    });
  }

  public setSelectAnnotation(annotation) {
    this.selectAnnotation = annotation;
    this.refreshAnnotation()
  }

  refresh(canvasRef: fabric.Canvas, relativePictureNumber, cameraNumber, mode, image: TchekImage, calcul = false) {//SBE
    console.log('annotation refresh ', relativePictureNumber, cameraNumber, mode, image);
    if (calcul) {
      this.polygons = new PolygonStore();
      this.listPolygons = [];
      this.retrievedRois.forEach(annotation => {
        const points = cloneDeep(annotation.get('polygons'));
        const uid = annotation.get('uid');
        let first = true;

        console.log('points :', this.fimage.width, this.fimage.height)
        points.forEach(point => {
          point.x = point.x * this.fimage.getScaledWidth() / this.fimage.width + this.fimage.left;
          point.y = point.y * this.fimage.getScaledHeight() / this.fimage.height + this.fimage.top;
          if (first) {
            this.polygons.add(new fabric.iPolygon([new fabric.iPoint(point.x, point.y)]), false, annotation.get('label'), annotation.id);
            first = false;
          } else {
            this.polygons.continue(new fabric.iPoint(point.x, point.y), annotation.get('label'), annotation.id);
          }
        });
        // console.log('init poly', annotation.get('label'), annotation.id);
        this.polygons.last().strokeDashArray = undefined;
        this.polygons.all().forEach(poly => {
          if (poly.points.length > 0) {
            const index = this.listPolygons.findIndex(a => (a.uid === poly.uid));
            if (index === -1) {
              const newPoly = {
                camera: annotation.get('folder'),
                sequence: annotation.get('sequence'),
                poly: poly,
                image: annotation.get('imagePtr') ? new TchekImage(annotation.get('imagePtr')) : undefined,
                uid: poly.uid, annotation: annotation,
                label: annotation.get('label'),
                id: annotation.id,
                type: annotation.get('type')
              };
              this.listPolygons.push(newPoly);
            }
          }
        });
      });
    }
    this.currentMode = mode;
    console.log('aaaa test2', this.currentMode);
    this.image = image
    if (this.createNewAnnotation === true) {
      this.createNewAnnotation = false;
      return this.setCanvasRef(canvasRef, relativePictureNumber, cameraNumber, this.tchekId, this.currentMode, this.image)
    }
    this.polygons = new PolygonStore();
    this.sequence = parseInt(relativePictureNumber, 10);
    this.cameraNumber = cameraNumber;
    this.canvasRef = canvasRef;
    this.refreshAnnotation();
  }

  /* Draws all polygons' vertices with no params or poly's vertices
    only if specified */
  private drawVertices(poly?: fabric.iPolygon) {
    const polygons = [];
    if (poly)
      polygons.push(poly);
    else
      polygons.push(...this.polygons.all());

    //if (this.selectAnnotation)
    polygons.forEach(poly => {
      poly.points.forEach((point: fabric.iPoint) => {
        let color = 'green'
        if (this.selectAnnotation && this.selectAnnotation.id)
          if (poly.id === this.selectAnnotation.id)
            color = 'red'
        this.canvasRef.add(new fabric.Circle({
          radius: 5,
          fill: color,
          objectCaching: false,
          left: point.x,
          top: point.y,
          originX: 'center',
          originY: 'center',
          hasBorders: false,
          hasControls: false,
          uid: point.uid,
          kind: 'vertex'
        }));
      });
    });
  }

  drawPolygons() {
    this.clearAnnotations();
    // console.log('store ', this.polygons, 'list', this.listPolygons);
    this.polygons.all().forEach((poly, i) => {
      this.canvasRef.add(poly);
      //      console.log('drawing', poly);
      if (poly.label && !this.precisionModeEnabled)
        this.drawLabel(poly, poly.label);
      this.drawVertices(poly);
    });
    this.canvasRef.renderAll();
  }

  drawLabel(poly, label) {
    const fLabelText = new fabric.Text(label, {
      fontSize: 16,
      fontFamily: 'Open Sans',
      fill: 'white',
      fontWeight: 'bold',
      originX: 'center',
      originY: 'center',
      draggable: false,
      selectable: false,
      lockRotation: true,
      hasControls: false,
      left: poly.getCenterPoint().x,
      top: poly.getCenterPoint().y,
      uid: 700,
      kind: 'label'
    });
    this.canvasRef.add(fLabelText);
  }

  private cancelDrawing() {
    this.setDrawingMode();
    this.polygons.pop();
    this.drawPolygons();
  }

  public saveImageActive(active: any[]) {
    let tchekPtr = {
      __type: 'Pointer',
      className: 'Tchek',
      objectId: this.tchekId
    }
    const ImageActiveQ = parse.Object.extend("ImageActive");
    let query = new parse.Query(ImageActiveQ);
    if (this.image)
      query.equalTo("imagePtr", this.image.getParseInstance());
    else {
      query.equalTo("folder", this.cameraNumber);
      query.equalTo("sequence", this.sequence);
    }
    query.equalTo("tchekPtr", tchekPtr);
    query.first().then(
      data => {
        console.log("saving image");
        if (!data) {
          const ImageActive = new parse.Object("ImageActive");
          ImageActive.set("folder", this.cameraNumber);
          ImageActive.set("sequence", this.sequence);
          if (this.image)
            ImageActive.set("imagePtr", this.image.getParseInstance());
          ImageActive.set("tchekPtr", tchekPtr);
          ImageActive.set("active", active);
          ImageActive.save()
        } else {
          data.set("folder", this.cameraNumber);
          data.set("sequence", this.sequence);
          data.set("tchekPtr", tchekPtr);
          if (this.image)
            data.set("imagePtr", this.image.getParseInstance());
          data.set("active", active);
          data.save()
        }
        return;
      },
      error => {
        console.log(error);
      }
    )
  }

  private finishDrawingPolygon() {
    this.setDrawingMode();
    this.polygons.last().strokeDashArray = undefined;
    this.drawPolygons();
    this.polygons.all().forEach((poly, i) => {
      if (poly.points.length > 0) {
        const index = this.listPolygons.findIndex(a => (a.uid === poly.uid));
        if (index === -1) {
          const newPoly = { camera: this.cameraNumber, sequence: this.sequence, poly: poly, uid: poly.uid };
          this.listPolygons.push(newPoly);
          this.saveAnnotation(poly);
        }
      }
    });
  }

  private addNextPoint({ pointer: p }: any, first?: boolean) {
    const pointer = this.canvasRef.getPointer(p.e);
    let x = pointer.x, y = pointer.y;
    // Limiting new points to inner image
    if (pointer.x < this.fimage.getCoords()[0].x) {
      x = this.canvasRef.backgroundImage.getCoords()[0].x;
    } else if (pointer.x > this.canvasRef.backgroundImage.getCoords()[2].x)
      x = this.canvasRef.backgroundImage.getCoords()[2].x;
    if (pointer.y < this.canvasRef.backgroundImage.getCoords()[0].y) {
      y = this.canvasRef.backgroundImage.getCoords()[0].y;
    } else if (pointer.y > this.canvasRef.backgroundImage.getCoords()[2].y)
      y = this.canvasRef.backgroundImage.getCoords()[2].y;

    p = new fabric.iPoint(x, y);
    // console.log('addNextPoint', p,pointer);
    if (first) { // Create a polygon with first point
      this.polygons.add(new fabric.iPolygon([p]), true, this.typeDamage);
    } else // Add a point to the last polygon
      this.polygons.continue(p, this.typeDamage);
    this.drawPolygons();
  }

  removePointFromPolygon(point: fabric.iPoint): boolean {
    return this.polygons.reduceOne(point);
  }

  removePolygon(canvas: any, polygon: any) {
    const points = canvas.getObjects().filter(pp => (pp.radius > 0));
    // console.log('objects filtered', points);
    points.forEach(point => {
      if (polygon.points.findIndex(p => (p.x === point.left && p.y === point.top)) > -1)
        canvas.remove(point);
    });
    canvas.fxRemove(polygon);
  }

  private deleteAnnotation(canvas: any) {
    // console.log('deleting annotation', canvas);
    const selectedPoly = canvas.getActiveObject();
    if (selectedPoly) {
      const listPoly = this.listPolygons.find(p => (p.uid === selectedPoly.uid));
      if (listPoly.annotation) {
        listPoly.annotation.destroy().then(res => {
          // this.removePolygon(canvas, selectedPoly);
          this.clearAnnotations();
          this.setCanvasRef(canvas, this.sequence, this.cameraNumber, this.tchekId, this.currentMode, this.image)
          console.log('success deleting annotation', res);
        });
      }
    }
  }

  objectMovingHandler = (e) => {
    clearTimeout(this.timer);
    this.timer = setTimeout(() => {
      let annotation;
      let listPolyNew
      if (this.currentMode === 'video') {
        listPolyNew = this.listPolygons.filter(a => (a.camera === this.cameraNumber));
        listPolyNew = listPolyNew.filter(a => (a.sequence === this.sequence));
      } else {
        console.log(this.listPolygons);
        listPolyNew = this.listPolygons.filter(a => (a.image.id === this.image.id));
      }
      this.polygons.all().forEach((poly2, i) => {
        const poly = JSON.parse(JSON.stringify(poly2)); //Object.assign({}, poly2)
        //if(listPolyNew[i] != undefined) annotation =listPolyNew[i].annotation;
        // console.log('annotation_', poly)
        poly.points = this.getRealCoordinate(poly.points);
        poly.points.forEach((point, j) => {
          if (point.uid === e.target.uid) {
            // console.log('listPolyNew', listPolyNew, i)
            //  if (listPolyNew[i] != undefined) {
            //   console.log('listPoly ', listPolyNew[i - 1])
            annotation = listPolyNew[i].annotation;
            annotation.set('polygons', poly.points);
            //  }
            //poly.points = listPolyNew[i-1].poly.points
            /* poly.points[j]=this.getRealCoordinate(poly.points[j])
            poly.points[j].x =   (point.x-this.fimage.left)/this.fimage.getScaledWidth()*this.fimage.width
            poly.points[j].y = (point.y-this.fimage.top)/this.fimage.getScaledHeight()*this.fimage.height */
          }
          j++;
        });
        i++;
      });
      console.log('updateAnnotation', annotation, this.drawingMode);
      if (annotation !== undefined && this.drawingMode !== true) {
        this.updateAnnotation(annotation);
      }
    }, 3000);
    // console.log('object:moving', e);
    this.polygons.setPointPos(e.target.uid, e.target.getCenterPoint().x, e.target.getCenterPoint().y);
    this.drawPolygons();
  }

  updateAnnotation(annotation) {
    annotation.save().then((savedRoi) => {
      this._toastService.toastOpen(undefined, this.i18n({
        id: 'savedAnnotation',
        value: "Annotation enregistrée",
        description: "Annotation enregistrée",
        meaning: "annotation"
      })
      );
      console.log('success', savedRoi);
    }, (error) => {
      console.error('Failed to create new ROI, with error: ' + error.code + ' ' + error.message);
    });
  }

  mouseWheelHandler = (event) => {
    this.setPrecisionMode(true);
  }

  mouseDownHandler = (event) => {
    if (event && event.e && event.e.ctrlKey)
      return;
    // console.log('mouse:down', event);

    const segment = this.computeClosestSegment(event.pointer);
    // console.log('closest', segment);

    if (this.drawingMode) {
      // Adding point to polygon being drawn atm
      return this.addNextPoint(event);
    } else if (segment.distance > AnnotationService._edgeDistanceThreshold) {
      if (event.target && event.target.get('type') !== 'circle') {
        // Creating first point of new polygon to draw
        this.setDrawingMode(true);
        return this.addNextPoint(event, true);
      }
    } else if (event.e.altKey) {
      /* Continue inserting point into existing polygon if click happened N px or
    less away from segment */
      const newPoint = this.computeOrthogonalProjection(event.pointer, segment);
      //TODO: logic to insert points goes here
    } else {
      // Select the appropriate object
      const closest = this.computeClosestPolygon(event.pointer);
      // console.log('closestPolygon', closest);
      this.canvasRef.setActiveObject(closest.poly);
    }


    // These are indicators for debugging
    const circle = new fabric.Circle({
      radius: 2,
      fill: 'red',
      left: segment.start.x,
      top: segment.start.y,
      originX: 'center',
      originY: 'center',
      hasBorders: false,
      hasControls: false,
      name: 'indic'
    });
    const circle1 = new fabric.Circle({
      radius: 2,
      fill: 'red',
      left: segment.end.x,
      top: segment.end.y,
      originX: 'center',
      originY: 'center',
      hasBorders: false,
      hasControls: false,
      name: 'indic'
    });
    // this.canvasRef.add(circle, circle1);
  }

  mouseUpHandler = (e) => {
    this.canvasRef.getObjects('circle').forEach(c => {
      if (c.name === 'indic')
        this.canvasRef.remove(c);
    });
  }

  keyUpHandler = (e) => { //SBE
    console.log('keyup', e.which, this.drawingMode);
    if (e.which === 13 && this.drawingMode) {
      this.finishDrawingPolygon();
    } else if (e.which === 27 && this.drawingMode) {
      this.cancelDrawing();
    } else if ((e.which === 46 || e.which === 8) && !this.drawingMode) {
      this.deleteAnnotation(e.data);
    } else if (e.which === 82) {
      this.setPrecisionMode(false);
    }
  }

  private setDrawingMode(enable?: boolean) {
    if (enable) this.drawingMode = true;
    else this.drawingMode = false;
  }

  computeDistanceToPoint(v: Point, w: Point): number {
    return (v.x - w.x) ** 2 + (v.y - w.y) ** 2;
  }

  computeDistanceToSegment(p: Point, v: Point, w: Point): number {
    const l2 = this.computeDistanceToPoint(v, w);
    if (l2 == 0) return this.computeDistanceToPoint(p, v);
    let t = ((p.x - v.x) * (w.x - v.x) + (p.y - v.y) * (w.y - v.y)) / l2;
    t = Math.max(0, Math.min(1, t));
    return Math.sqrt(this.computeDistanceToPoint(p, {
      x: v.x + t * (w.x - v.x),
      y: v.y + t * (w.y - v.y)
    }));
  }

  computeClosestSegment(p: Point): ClosestSegment {
    let minDist = Infinity;
    let dist = Infinity;
    let closest = new ClosestSegment({ x: -1, y: -1 }, { x: -1, y: -1 }, Infinity);

    for (let j = 0; j < this.polygons.all().length; j++) {
      for (let i = 0; i < this.polygons.get(j).points.length; i++) {
        if (i === this.polygons.get(j).points.length - 1) // compare last point to first point
          dist = this.computeDistanceToSegment(p, this.polygons.get(j).points[i], this.polygons.get(j).points[0]);
        else
          dist = this.computeDistanceToSegment(p, this.polygons.get(j).points[i], this.polygons.get(j).points[i + 1]);

        if (dist < minDist) {
          minDist = dist;
          closest = new ClosestSegment(
            this.polygons.get(j).points[i],
            this.polygons.get(j).points[i === this.polygons.get(j).points.length - 1 ? 0 : i + 1],
            minDist);
        }
      }
    }
    // console.log('closest segment to point', p, ':', closest);
    return closest;
  }

  computeClosestPolygon(p: Point): any {
    let minDist = Infinity;
    let dist = Infinity;
    let closestPolygon;

    for (let j = 0; j < this.polygons.all().length; j++) {
      for (let i = 0; i < this.polygons.get(j).points.length; i++) {
        if (i === this.polygons.get(j).points.length - 1) // compare last point to first point
          dist = this.computeDistanceToSegment(p, this.polygons.get(j).points[i], this.polygons.get(j).points[0]);
        else
          dist = this.computeDistanceToSegment(p, this.polygons.get(j).points[i], this.polygons.get(j).points[i + 1]);

        if (dist < minDist) {
          minDist = dist;
          closestPolygon = { poly: this.polygons.get(j), dist };
        }
      }
    }
    // console.log('closest segment to point', p, ':', closest);
    return closestPolygon;
  }

  computeOrthogonalProjection(point: Point, segment: Segment): Point {
    const a = segment[0],
      b = segment[1],
      c = point;

    if (a === undefined || b === undefined || c === undefined)
      return { x: -1, y: -1 };

    const k = ((b.y - a.y) * (c.x - a.x) - (b.x - a.x) * (c.y - a.y)) / ((b.y - a.y) ** 2 + (b.x - a.x) ** 2);
    const h = {
      x: c.x - k * (b.y - a.y),
      y: c.y + k * (b.x - a.x)
    };

    return h;
  }

  public getRealCoordinate(points): any {
    points = JSON.parse(JSON.stringify(points));
    points.forEach(point => {
      point.x = (point.x - this.fimage.left) / this.fimage.getScaledWidth() * this.fimage.width;
      point.y = (point.y - this.fimage.top) / this.fimage.getScaledHeight() * this.fimage.height;
    });
    return points;
  }

  saveAnnotation(polygon) {
    const _annotation = parse.Object.extend('Annotation');
    const annotation = new _annotation();
    const newPoints = this.getRealCoordinate(polygon.points);
    annotation.set('polygons', newPoints);
    annotation.set('tchekPtr', {
      __type: 'Pointer',
      className: 'Tchek',
      objectId: this.tchekId
    });
    annotation.set('type', this.type);


    if (this.currentMode === 'video') {
      annotation.set('sequence', this.sequence);
      annotation.set('folder', this.cameraNumber);
    } else {
      annotation.set('imagePtr', {
        __type: 'Pointer',
        className: 'Images',
        objectId: this.image.id
      });
    }

    annotation.set('label', this.typeDamage);
    annotation.set('uid', polygon.uid);
    annotation.set("userPtr", parse.User.current())
    /*
    roiToSave.set('toSync', true);
    const acl = new parse.ACL();
    acl.setPublicReadAccess(false);
    acl.setPublicWriteAccess(false);
    acl.setRoleReadAccess('superAdmin', true);
    acl.setRoleWriteAccess('superAdmin', true);
    acl.setRoleReadAccess(parse.User.current().get('roleCompany'), true);
    acl.setRoleWriteAccess(parse.User.current().get('roleCompany'), true);
    roiToSave.setACL(acl); */
    annotation.save().then((savedRoi) => {
      this.newAnnotation.next()
      this._toastService.toastOpen(undefined, this.i18n({
        id: 'newAnnotation',
        value: "Nouvelle annotation",
        description: "Nouvelle annotation",
        meaning: "annotation"
      })
      );
      this.createNewAnnotation = true;
      this.newQueueAnnotation()
      // console.log('success', savedRoi);
      this.listPolygons[this.listPolygons.length - 1].annotation = savedRoi;
    }, (error) => {
      console.error('Failed to create new ROI, with error: ' + error.code + ' ' + error.message);
      console.warn(error);
    });
  }

  createAnnotation(points: Array<any>, label: string,
    attribute: { name: string, value: string }[],
    pictureNumber: number,
    cameraNumber: string,
    damageId: string,
    roiId: string,
    type?: number, uid?: number, user?: Parse.Object) {

    console.log('creating annotation', label, pictureNumber, cameraNumber, points, type, uid);
    const _annotation = parse.Object.extend('Annotation');
    const annotation = new _annotation();
    annotation.set('polygons', points);
    annotation.set('tchekPtr', {
      __type: 'Pointer',
      className: 'Tchek',
      objectId: this.tchekId
    });
    annotation.set('type', type ? type : 0);
    annotation.set('label', label);
    annotation.set('attributes', attribute);

    if (this.currentMode === 'video') {
      annotation.set('sequence', this.sequence);
      annotation.set('folder', this.cameraNumber);
    } else {
      let imageOriginalId = this.image.parentPtr ? this.image.parentPtr.id : this.image.id
      annotation.set('imagePtr', {
        __type: 'Pointer',
        className: 'Images',
        objectId: imageOriginalId
      });
    }

    annotation.set('damagePtr', {
      __type: 'Pointer',
      className: 'Damage',
      objectId: damageId
    });
    annotation.set('roiPtr', {
      __type: 'Pointer',
      className: 'Roi',
      objectId: roiId
    });
    annotation.set('uid', uid);
    annotation.set('userPtr', user);
    annotation.save().then((savedRoi) => {
      if (savedRoi) {
        this.createNewAnnotation = true;
        //this.newQueueAnnotation() inutile car on ne peux pas classifier si image non hd 

        // this.polygons.add(savedRoi.get('polygons'), false, savedRoi.get('label'));
        // this.theTimer = setTimeout(() => {
        //   this.drawPolygons();
        // }, 200);
        //this.refreshAnnotation()
      }
      //console.log('success annotation', savedRoi);
      //console.log(this.listPolygons);
      //this.listPolygons[this.listPolygons.length - 1].annotation = savedRoi;
    }, (error) => {
      console.error('Failed to create new ROI, with error: ' + error.code + ' ' + error.message);
      console.warn(error);
    });
  }

  getAnnotation(tchek): Promise<any> {
    return new Promise((resolve, reject) => {
      const query = new parse.Query(parse.Object.extend('Annotation'));
      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: tchek
      });
      query.include("userPtr")
      query.include("imagePtr")
      //query.equalTo('folder', this.cameraNumber);
      query.limit(1000).find().then((retrievedAnnotations: any) => {
        // console.log('retrievedAnnotations', retrievedAnnotations);

        const knownFolders = []; // list of thceks folders for annotaion.
        for (let i = 0; i < retrievedAnnotations.length; i++) {
          if (retrievedAnnotations[i].get('folder') !== undefined && !knownFolders.includes(retrievedAnnotations[i].get('folder'))) {
            knownFolders.push(retrievedAnnotations[i].get('folder'));
          }
        }

        // TODO: remove this when `folderPtr` is supported by Annotation
        this._tchekService.getFolder(tchek).then(folders => {
          for (let i = 0; i < retrievedAnnotations.length; i++) {
            const folder = folders.find(f => (f.get('name') === retrievedAnnotations[i].get('folder')));
            if (folder)
              retrievedAnnotations[i].folderPtr = folder;
          }
          resolve(retrievedAnnotations);
        });
      }, (error) => {
        console.error('Could not retrieve annotations : ', error.code, error.message);
        reject(error);
      });
    });
  }

  groupAnnotationsByCamera(annotations) {
    if (!annotations || annotations.length < 1)
      return console.warn('Cannot group by camera', annotations);

    const knownCameras = [];
    const groupedAnnotations = {};
    annotations.forEach(r => {
      if (knownCameras.includes(r.get('folder')))
        groupedAnnotations[r.get('folder')].push(r);
      else {
        groupedAnnotations[r.get('folder')] = [r];
        knownCameras.push(r.get('folder'));
      }
    });
    // console.log('groupedAnnotations', groupedAnnotations);
    return groupedAnnotations;
  }

  clearAnnotations() {
    const annotationElements = this.canvasRef.getObjects().filter(o => (o.kind === 'label' || o.kind === 'vertex' || o.kind === 'annotation'));
    this.canvasRef.remove(...annotationElements);
  }

  setPolygonsSelectable(enable?: boolean) {
    this.allowPolygonSelection = enable ? true : false;
    this.polygons.setPolygonsSelectable(this.allowPolygonSelection);
  }

  setPrecisionMode(enable?: boolean) {
    if (this.precisionModeEnabled === enable)
      return;
    this.precisionModeEnabled = enable;
    const annotations = this.canvasRef.getObjects().filter(o => (o.kind === 'annotation'));
    const vertices = this.canvasRef.getObjects().filter(o => (o.kind === 'vertex'));
    // console.log('annotations', annotations);
    // console.log('vertices', vertices);
    annotations.forEach(poly => {
      if (enable)
        poly.strokeWidth = .5;
      else
        poly.strokeWidth = this.polygons._normalPolyOptions.strokeWidth;
    });
    vertices.forEach(vert => {
      if (enable)
        vert.radius = .7;
      else
        vert.radius = 5;
    });

    if (!enable) {
      this.canvasRef.renderAll();
      this.canvasRef.setZoom(1);
    }
  }

  existAnnotationQueue(): Promise<any> {
    return new Promise((resolve, reject) => {
      const query = new parse.Query(parse.Object.extend('QueueAnnotation'));
      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: this.tchekId
      });
      query.equalTo('sequence', this.sequence);
      query.equalTo('folder', this.cameraNumber);
      query.first().then(
        result => {
          if (!result)
            resolve(false)
          else
            resolve(true)
        },
        error => {
          console.log(error);
        }
      )
    });
  }

  existDamageHD(): Promise<any> {
    return new Promise((resolve, reject) => {
      const Roi = parse.Object.extend('Roi');
      const queryRoi = new parse.Query(Roi);
      queryRoi.equalTo('picture', this.sequence);
      queryRoi.equalTo('folder', this.cameraNumber);


      const query = new parse.Query(parse.Object.extend('Damage'));
      query.equalTo('tchekPtr', {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: this.tchekId
      });
      query.equalTo("uploadPicture", true)
      query.include("roiPtr")
      query.matchesQuery('roiPtr', queryRoi);

      query.first().then(
        result => {
          if (!result)
            resolve(false)
          else
            resolve(true)
        },
        error => {
          console.log(error);
        }
      )
    });
  }

  newQueueAnnotation() {
    Promise.all([this.existAnnotationQueue(), this.existDamageHD()]).then(resolvedPromises => {

      if (resolvedPromises.includes(true))
        return;

      const _queueAnnotation = parse.Object.extend('QueueAnnotation');
      const queueAnnotation = new _queueAnnotation();

      let tchekPtr = {
        __type: 'Pointer',
        className: 'Tchek',
        objectId: this.tchekId
      }
      queueAnnotation.set('tchekPtr', tchekPtr);

      queueAnnotation.set('sequence', this.sequence);
      queueAnnotation.set('folder', this.cameraNumber);
      queueAnnotation.set("userPtr", parse.User.current())
      if (!environment.isLocal)
        queueAnnotation.set('toSync', true);

      queueAnnotation.set('isDownload', false);

      let acl = new parse.ACL();
      acl.setPublicReadAccess(false);
      acl.setPublicWriteAccess(false);
      acl.setRoleReadAccess('superAdmin', true);
      acl.setRoleWriteAccess('superAdmin', true);
      this._tchekService.getTchek(this.tchekId)
        .then(tchek => {

          if (tchek.get('uploadHDPictures') && tchek.get('videoConverter') !== 2 && tchek.get('toDownload') !== 1)
            return;

          if (tchek)
            for (let [key, value] of Object.entries(tchek.getACL())) {
              for (let [k, v] of Object.entries(value)) {
                if (k.split(':')[1]) {
                  acl.setRoleReadAccess(k.split(':')[1], v.read);
                  acl.setRoleWriteAccess(k.split(':')[1], v.write);
                }
              }
            }
          queueAnnotation.setACL(acl);
          queueAnnotation.save().then((savedAnnotationQueue) => {
            console.log("Saved QueueAnnotation ", savedAnnotationQueue);
          }, (error) => {
            console.error('Failed to create new AnnotationQueue , with error: ' + error.code + ' ' + error.message);
            console.warn(error);
          });
        })
    })

  }
}



// WEBPACK FOOTER //
// ./src/app/service/annotation.service.ts